import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedService } from '@services/shared.service';

import { ModalBase } from '@shared/modal-base.component';

import { ShippingProviderModel, ShippingProviderType } from '@models/ShippingModel';
import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';


@Component({
    selector: 'app-givi-express-modal',
    templateUrl: './givi-express-modal.component.html',
    styleUrls: ['./givi-express-modal.component.scss']
})
export class GiviExpressModalComponent extends ModalBase<ShippingProviderModel> implements OnInit {

    @ViewChild('sendGiviExpressModal', { static: true }) modal: TemplateRef<any>;

    @Input() givi: SmartListTransactionItem;
    @Input() provider: ShippingProviderModel;
    @Input() isButton = false;
    @Input() isCoupon = false;
    @Input() isGiftcard = false;


    constructor(
        public sharedService: SharedService,
        public modalService: NgbModal) {
        super(modalService);
    }

    ngOnInit(): void {
    }

    onOpen() {

        super.open(this.modal, {
            backdrop: 'static', keyboard: false,
            windowClass: 'modal-dialog-end'
        });
    }

    onClose() {

        super.close();
    }

    onSendCode() {

        if (this.givi) {

            /* Rellena el id con ceros a la izquierda para garantizar que tenga al menos 5 caracteres. */
            const orderId = (this.givi.id.toString()).padStart(5, '0');
            const vendorId = (this.givi.vendorId.toString()).padStart(4, '0');

            // Implementing a numeric variant on "amazingly safe" rot13 algorithm: rot5.
            const list = '5678901234'.split('');
            const vendorIdRot5 = (vendorId).split('').map(x => list[x]).join('');

            const hash = `${orderId}-${vendorIdRot5}`;

            // const decrypt = (vendorIdRot5).split('').map(x => list[x]).join('');

            let text = `Solicitar Express. Givi: ${this.givi.productName}. Código: ${hash}`;
            if (this.provider.type == ShippingProviderType.Express) {
                text = `Solicitar Canje Remoto con Envío. Givi: ${this.givi.productName}. Código: ${hash}`;
            } else if (this.provider.type == ShippingProviderType.Appointment) {
                text = `Solicitar Canje Remoto con Reservación. Givi: ${this.givi.productName}. Código: ${hash}`;
            }
            text = text.replace(/\s/g, '%20');

            let phone = this.provider.whatsappPhone.replace(/[-]/g, '');

            window.open(`http://wa.me/506${phone}?text=${text}`);
        }
    }
}
